import { useEffect } from 'react';
import { Text, Link, LinkList } from '@postenbring/hedwig-react';

export const RedirectToDownload = ({ appUrl, isEdit, message }) => {

    useEffect(() => {
        if (!isEdit) {
            // Redirect to the download URL

            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const iOS = /iPad|iPhone|iPod|Mac OS/.test(userAgent) && !window.MSStream;

            if (iOS) {
                window.location.href = appUrl.urlForIos;
            } else {
                window.location.href = appUrl.urlForAndroid;
            }
        }
    }, []);



    return (
        <>
            {isEdit &&
                <Text className="hds-mb-20-24">This part will redirect the user to App Store or Google play on page load</Text>
            }
            <Text className="hds-mb-20-24">{message}</Text>
            <LinkList className="hds-mb-20-24">
                <li>
                    <Link href={appUrl.urlForIos} target="_blank">{appUrl.linkTextIos}</Link>
                </li>
                <li>
                    <Link href={appUrl.urlForAndroid} target="_blank">{appUrl.linkTextAndroid}</Link>
                </li>
            </LinkList>

        </>
    )
}

